export const MCCategoryIds = {
    NOTES_REQUIRING_APPROVAL: 'NOTES_REQUIRING_APPROVAL',
    NOTES_PENDING_ACTION: 'NOTES_PENDING_ACTION',
    PEER_REVIEW_WC: 'PEER_REVIEW_WC',
    PEER_REVIEW_FEDERAL: 'PEER_REVIEW_FEDERAL',
    PEER_REVIEW_SPECIAL_PROG: 'PEER_REVIEW_SPECIAL_PROG',
    PROGRESS_DUE: 'PROGRESS_DUE',
    DISCHARGE_DUE: 'DISCHARGE_DUE',
    DIARY_TASKS: 'DIARY_TASKS',

}

export const MCCategories = [
    {
        id: MCCategoryIds.NOTES_REQUIRING_APPROVAL,
        name: 'Notes Requiring Approval',
        entityKey: 'notesReqApproval',
        includeInMsgCount: true,
        enabled: true,
    },
    {
        id: MCCategoryIds.NOTES_PENDING_ACTION,
        name: 'Notes Pending Action',
        entityKey: 'notesPendingAction',
        includeInMsgCount: true,
        enabled: true,
    },
    {
        id: MCCategoryIds.PEER_REVIEW_WC,
        name: 'Peer Review - Work Comp',
        entityKey: 'peerReviewWorkComp',
        includeInMsgCount: true,
        enabled: false,
    },
    {
        id: MCCategoryIds.PEER_REVIEW_FEDERAL,
        name: 'Peer Review - Federal',
        entityKey: 'federalReviewMsgs',
        includeInMsgCount: true,
        enabled: false,
    },
    {
        id: MCCategoryIds.PEER_REVIEW_SPECIAL_PROG,
        name: 'Peer Review - Specialty Prog.',
        entityKey: 'specProgReqMsgs',
        includeInMsgCount: true,
        enabled: true,
    },
    {
        id: MCCategoryIds.PROGRESS_DUE,
        name: 'Progress Due',
        entityKey: 'pnDue',
        includeInMsgCount: false,
        enabled: true,
    },
    {
        id: MCCategoryIds.DISCHARGE_DUE,
        name: 'Discharges Due',
        entityKey: 'dcDue',
        includeInMsgCount: false,
        enabled: true,
    },
    {
        id: MCCategoryIds.DIARY_TASKS,
        name: 'Diary Tasks',
        entityKey: 'mcDiaryItems',
        includeInMsgCount: true,
        enabled: true,
    }
]
